import React, { useState } from "react";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import { Eye, EyeOff } from "lucide-react";
import { FormattedMessage } from "react-intl";

export default function PasswordField({
  name,
  labelId,
  handleInputValue,
  errors,
  color = "primary",
  size = "small",
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      fullWidth
      required
      type={showPassword ? "text" : "password"}
      style={{ marginTop: "8px" }}
      variant="outlined"
      onBlur={handleInputValue}
      onChange={handleInputValue}
      name={name}
      size={size}
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "12px",
          backgroundColor: "#fff",
        },
      }}
      {...(errors[name] && {
        error: errors[name] && errors[name] != "",
        helperText: errors[name] || "",
      })}
      label={<FormattedMessage id={labelId} />}
      color={color}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <Eye size={20} color="hsl(220, 10%, 46%)" />
              ) : (
                <EyeOff size={20} color="hsl(220, 10%, 46%)" />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
    ></TextField>
  );
}
